// extracted by mini-css-extract-plugin
export default {"toast_mui":"toastMui_toast_mui__4zIsr","close":"toastMui_close__3DtGM"};